import { Pipe, PipeTransform } from '@angular/core';
import { deviceSortType } from '../constants/device-sort-type';
import { statusPriorities } from '../constants/status-priorities';

@Pipe({
  name: 'deviceSort'
})
export class DeviceSortPipe implements PipeTransform {

  transform<T extends { name: string; type: string; status: { statusCode: number } }>(data: T[], sortType: deviceSortType): T[] {
    switch (sortType) {
      case deviceSortType.name:
        return data.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
      case deviceSortType.type:
        return data.sort((a, b) => {
          return a.type.localeCompare(b.type);
        });
      case deviceSortType.status:
        return data.sort((a, b) => {
          return statusPriorities[a.status.statusCode].priority < statusPriorities[b.status.statusCode].priority ? -1 : 1;
        });
      default:
        return data.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
    }
  }

}
